<template>
	<div>
		<DefaultWidgetField v-bind="defaultFieldProps" v-on="defaultFieldListeners" />
		<div class="flex-space-between--center switch-field">
			<div>{{ switchLabel }}</div>
			<v-switch class="dark small" v-model="isValueTrue" inset dense color="white" />
		</div>
	</div>
</template>
<script>
import WidgetFieldMixin from './WidgetFieldMixin';

import DefaultWidgetField from './DefaultWidgetField';

export default {
	name: 'SwitchField',
	components: { DefaultWidgetField },
	mixins: [WidgetFieldMixin],
	computed: {
		switchLabel() {
			return this.field.metadata.options.switch_label;
		},
		isValueTrue: {
			get() {
				return [true, 'true'].includes(this.value);
			},
			set(v) {
				this.value = v;
			},
		},
	},
};
</script>

<style scoped lang="scss">
.switch-field {
	::v-deep {
		.dark .v-input--switch__track {
			background: #707070 !important;
		}
		.dark.v-input--is-label-active .v-input--switch__track {
			background: var(--bold-border-color) !important;
		}
		.small {
			transform: scale(0.75);
		}
		.v-input--selection-controls {
			padding-top: 0px;
		}
		.v-input--switch__track {
			background: #ced0da !important;
			opacity: 1 !important;
			transition: all 0.15s;
		}
		.v-input--is-label-active .v-input--switch__track {
			opacity: 1 !important;
			background: var(--bold-border-color) !important;
		}
	}
}
</style>
